import React from "react";
import "../Styling/Navi1CustomTable.css";

const Navi1CustomTable = ({ columns, data, boxShadow }) => {
  return (
    <div className={`Navi1CustomTableContainer ${boxShadow ? "with-shadow" : ""}`}>
      <table>
        <thead style={{borderRadius:"20px"}}>
          <tr >
            {columns.map((col, index) => (
              <th key={index} className="custom-header">
                {col.header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <td key={colIndex}>
                    {col.render ? col.render(row) : row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="NoData">
                No Data Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Navi1CustomTable;